import DropdownPopOut from '../Dropdown/DropdownPopOut'
import classes from './ItemMenu.module.scss'
import { FiMoreHorizontal } from 'react-icons/fi'
import  { type options as OptionsType } from '../types'
import { type ReactNode } from 'react'

export interface Props {
  preferredPosition?: 'right-auto' | 'right'
  onSelect: (value: string) => void
  options: OptionsType
  customButton?: ReactNode
}

const MaterialTableItemMenu = ({
  preferredPosition = 'right',
  onSelect,
  options,
  customButton
}: Props) => {
  const renderCustomButton = (ref?: any, onClick?: any) =>
    <button
      aria-label='open actions menu'
      className={classes.CustomButton}
      onClick={onClick}
      ref={ref}
      type='button'
    >
      <div className={classes.IconWrapper}>
        {customButton}
      </div>
    </button>

  const renderButton = (ref?: any, onClick?: any) =>
    <button
      aria-label='open actions menu'
      className={classes.ItemMenuButton}
      onClick={onClick}
      ref={ref}
      type='button'
    >
      <FiMoreHorizontal
        aria-hidden
        size='20px'
      />
    </button>

  return (
    <DropdownPopOut
      onSelect={onSelect}
      options={options}
      preferedPosition={preferredPosition}
      renderButton={
        customButton
          ? renderCustomButton
          : renderButton
      }
    />
  )
}

export default MaterialTableItemMenu
